/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Number/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Number({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceCarrierForm/Phone/Number",
  isInvalid,
  onChange
  
}) {
let phoneContactMethodPhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'phone',
path: 'contact_method.phone.number',
format: fromFormat.phoneNumberUS,
})
let phoneContactMethodPhoneNumberIsValidData = fromData.useDataIsValid({ viewPath,
context: 'phone',
path: 'contact_method.phone.number',
validate: fromValidate.phoneNumber,
})
let phoneContactMethodPhoneNumberChangeData = fromData.useDataChange({ viewPath,
context: 'phone',
path: 'contact_method.phone.number',
formatOut: fromFormat.addPrefixIfMissing,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 flexBasis={2}
 flexGrow={2}
 marginLeft={dtSpaceS}
 data="phone.contact_method.phone.number"
 format="/Data/format.js phoneNumberUS"
 formatOut="/Data/format.js addPrefixIfMissing"
 validate="/Data/validate.js phoneNumber"
 invalid={!phoneContactMethodPhoneNumberIsValidData}
 value={phoneContactMethodPhoneNumberValueData}
 onChange={phoneContactMethodPhoneNumberChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Number"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="phone"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}